import { FormInput, FormLabel, Form, Button, Text } from '$components'
import z from 'zod'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { invitationSendVerificationCodeMutation } from '$api-client/@tanstack/react-query.gen'
import { InvitationRoutePath } from '../routes/public'
import { Router } from '$utils/router'
import { useInvitation } from '../components/invitation-provider'
import { InvitationFooter } from '../components/invitation-footer'

export enum Input {
  Email = 'email',
}

const schema = z.object({
  email: z.string().email('Invalid email address').trim(),
})

export type AcceptInvitationFormValues = z.infer<typeof schema>

export function InvitationVerifyPage() {
  const { invitation, token } = useInvitation()
  const navigate = useNavigate()

  const { mutate: sendVerificationCode, isPending: isSendingVerificationCode } = useMutation({
    ...invitationSendVerificationCodeMutation(),
  })

  const onSubmit = async (values: AcceptInvitationFormValues) => {
    sendVerificationCode({
      body: values,
    })

    navigate(Router.getRoute(InvitationRoutePath.InvitationsCode, { token }))
  }

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="flex flex-col w-full max-w-[420px]">
        <Text
          type="h1"
          className="mb-stack-tight"
        >
          You have been invited to join <span className="text-fg-link"> {invitation.business_name} </span>!
        </Text>

        <Text
          type="p"
          className="mb-stack-grid mt-stack-tight"
        >
          Complete your account setup to join the team.
        </Text>

        <Form
          onSubmit={onSubmit}
          schema={schema}
          defaultValues={{
            [Input.Email]: invitation.email,
          }}
        >
          {() => (
            <div className="flex flex-col gap-stack-roomy">
              <div className="flex flex-col gap-stack-tight">
                <FormLabel htmlFor={Input.Email}>Email</FormLabel>
                <FormInput
                  name={Input.Email}
                  disabled
                />
              </div>

              <Button
                type="submit"
                size="lg"
                className="mt-stack-roomy"
                isLoading={isSendingVerificationCode}
                disabled={isSendingVerificationCode}
              >
                Continue
              </Button>
            </div>
          )}
        </Form>

        <InvitationFooter />
      </div>
    </div>
  )
}
